"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useTheme_1 = require("@cvent/carina/components/ThemeProvider/useTheme");
/**
 * Very simple wrapper around useTheme that enhances the return type
 * to include the block color stack.
 */
function useTheme() {
    var theme = (0, useTheme_1.useTheme)();
    return (0, react_1.useMemo)(function () {
        // Stub in extra data when missing for unit tests
        if (!theme.block) {
            return __assign(__assign({}, theme), { block: {
                    base: '',
                    container: '',
                    accent: '',
                    hover: '',
                    baseIndexInStack: 0,
                    blockColorKey: 'mood',
                    isLight: false,
                    isDark: false,
                    isWhite: false,
                    isCloseToWhite: false,
                    font: {
                        headings: {
                            fontFamily: ''
                        }
                    }
                }, palette: {
                    primary: '',
                    secondary: '',
                    background: '',
                    mood: '',
                    safeMode: true,
                    preferFormula: null,
                    headingFont: null,
                    bodyFont: null
                } });
        }
        return theme;
    }, [theme]);
}
exports.default = useTheme;
//# sourceMappingURL=useTheme.js.map